import { CardHeader } from "reactstrap";
import { H5 } from "../../../../../AbstractElements";
import { useAppDispatch } from "../../../../../Redux-Toolkit/Hooks";
import { Filters } from "../../../../../Constant";
import { setSideBarOn } from "../../../../../Redux-Toolkit/Reducers/FilterSlice";

export const FilterHeader = () => {
  const dispatch = useAppDispatch();

  return (
    <CardHeader>
      <H5 className="mb-0 f-w-400">
        {Filters}
        <span className="pull-right" onClick={() => dispatch(setSideBarOn())}>
          <i className="fa fa-chevron-down toggle-data"></i>
        </span>
      </H5>
    </CardHeader>
  );
};
